import React, { useState } from 'react'
import car1 from '../../assets/assets/images/home_images/home_grid1.png'
import { BsCreditCardFill, BsFillFuelPumpFill } from "react-icons/bs";
import googlePay from '../../assets/assets/images/social_icons/google_pay.png'
import cod from '../../assets/assets/images/social_icons/cod.png'
import paypal from '../../assets/assets/images/social_icons/paypal.png'
import TextInput from '../fields/TextInput';
import { Link } from 'react-router-dom';
import { MdDoubleArrow, MdPersonOutline } from 'react-icons/md';
import { LuAirVent } from 'react-icons/lu';
import { FaMusic } from 'react-icons/fa';
import { IoPerson } from 'react-icons/io5';
import { HiColorSwatch } from 'react-icons/hi';
import { GrManual, GrStar } from 'react-icons/gr';
import { RxDotFilled } from 'react-icons/rx';
import { Checkbox } from '@mui/material';

const Index = () => {

    const [checked, setChecked] = useState(false);
    const [inputField, setInputField] = useState({
        payment: 'Card'
    })

    const [info, setInfo] = useState({
        pickAddress: "264 Royal Ln. Mesa, New Jersey 45453",
        returnAddress: "264 Royal Ln. Mesa, New Jersey 45453",
        PickupDate: "11/12/2024 02:34 am",
        returnDate: "12/12/2024 02:34 am",
    })



    const inputsHandler = (e) => {
        setInputField({ ...inputField, [e.target.name]: e.target.value })
    }


    const handleChange = (event) => {
        setChecked(event.target.checked);
    };



    return (
        <div className='container pt-3 ps-3 pe-3 pb-6' >
            <div className='d-flex flex-row fs-1 accentColor align-items-center mt-2 mb-4' >
                <span className='lh-0' ><MdDoubleArrow /></span><span className='font' >Payment Method</span>
            </div>
            {/* <h2 className='font accentColor mt-2 mb-4' ><MdDoubleArrow />Payment Method</h2> */}
            <div className='row' >
                <div className='col-md-7' >
                    <p className='text-secondary fs14 fw-medium' >Total Charges</p>
                    <p className='fs2 accentColor font' >K540</p>

                    <div className='pt-3' >
                        <div className='d-flex align-items-center gap-3 pb-2' >
                            <h4 className='secondaryColor fw-normal' >McLaren 750s</h4>
                            <p className=' rounded-5 px-2 driver-badge' ><RxDotFilled className=' my-auto' />With Driver</p>
                        </div>

                        <div className="card radio-shadow">
                            <div className="card-body">
                                <div className='row' >
                                    <div className='col-sm-3 col-12 my-auto' >
                                        <img src="https://t3.ftcdn.net/jpg/01/23/52/24/240_F_123522493_qV0XZfz5gH3zeWFq1YiNCwpDT8HPfvZL.jpg" className='img-fluid' />
                                    </div>
                                    <div className='col-sm-5 col-7 my-auto pt-3 pt-md-0 fs14' >
                                        <p className='mb-1' >Rent Per day</p>
                                        <p className='mb-1' >Two days Rent</p>
                                        <p className='mb-1' >Driver charges</p>
                                    </div>
                                    <div className='col-sm-4 col-5 my-auto pt-3 pt-md-0  fs14 text-end' >
                                        <p className='mb-1 font fs18 fw-semibold' >K220</p>
                                        <p className='mb-1 font fs18 fw-semibold' >K440</p>
                                        <p className='mb-1 font fs18 fw-semibold' >K50</p>
                                    </div>
                                </div>
                                <hr />
                                <dl className="row mb-0">
                                    <dt className="col-8">Total payment</dt>
                                    <dt className="col-4 text-end font fs18 fw-semibold">K540</dt>
                                </dl>
                            </div>
                        </div>

                    </div>


                    <div className="wizard mt-2">
                        <div className="v-line"></div>
                        <div className="step-dot">
                            <div>
                                <h6 className='accentColor' >Pick-up</h6>
                                <div className='mt-2' >
                                    <p className='text-secondary fs14' >{info.pickAddress}</p>
                                    <p className='text-secondary fs14' >{info.PickupDate}</p>
                                </div>
                            </div>
                        </div>
                        <div className="step-dot">
                            <div>
                                <h6 className='accentColor' >Drop-off</h6>
                                <div className='mt-2' >
                                    <p className='text-secondary fs14' >{info.pickAddress}</p>
                                    <p className='text-secondary fs14' >{info.returnDate}</p>
                                </div>
                            </div>
                        </div>

                    </div>


                </div>



                <div className='col-md-5 px-lg-5' >
                    <h4 className='text-secondary mt-4 mt-md-0 mb-3' >Select a Payment Method</h4>

                    <div onChange={inputsHandler} >
                        <div>
                            <div className='d-flex my-2 flex-row card px-4 py-2 justify-content-between align-items-center' >
                                <div>
                                    <label htmlFor='card' ><BsCreditCardFill className='credit-icon' />Card</label>
                                </div>
                                <div>
                                    <input type="radio" className='form-check-input' id='card' value="Card" name="payment" checked={inputField.payment === "Card"} />
                                </div>
                            </div>
                            {inputField.payment === "Card" ?

                                <div className='row my-3 ' >
                                    <div className=' mb-3 col-12' >
                                        <TextInput
                                            type="text"
                                            placeholder="Card Number"
                                            id="cardNumber"
                                            size="small"
                                            varient='filled'
                                        />
                                    </div>
                                    <div className=' mb-3 col-6' >
                                        <TextInput
                                            type="text"
                                            placeholder="MM/YY"
                                            id="month"
                                            size="small"
                                            varient='filled'
                                        />

                                    </div>
                                    <div className=' mb-3 col-6' >
                                        <TextInput
                                            type="text"
                                            placeholder="CVV"
                                            id="cvv"
                                            size="small"
                                            varient='filled'
                                        />

                                    </div>
                                    <div className=' mb-3 col-12' >
                                        <TextInput
                                            type="text"
                                            placeholder="Card Holder Name"
                                            id="cardHolderName"
                                            size="small"
                                            varient='filled'
                                        />

                                    </div>

                                </div>
                                : null
                            }
                        </div>

                        <div>
                            <div className='d-flex my-2 flex-row card px-4 py-2 justify-content-between align-items-center' >
                                <div>
                                    <label htmlFor='paypal' >
                                        <img src={paypal} className='payment-icon' />

                                        Paypal
                                    </label>
                                </div>
                                <div>
                                    <input type="radio" className="form-check-input" id='paypal' value="Paypal" name="payment" checked={inputField.payment === "Paypal"} />
                                </div>
                            </div>
                            {inputField.payment === "Paypal" ?
                                <div className='my-3' >
                                    <div className=' mb-3' >
                                        <TextInput
                                            type="text"
                                            placeholder="Enter Your Email Id"
                                            id="paypalEmail"
                                            size="small"
                                            varient='filled'
                                        />

                                    </div>
                                </div> : null
                            }
                        </div>

                        <div>
                            <div className='d-flex my-2 flex-row card px-4 py-2 justify-content-between align-items-center' >
                                <div>
                                    <label htmlFor='google' >
                                        <img src={googlePay} className='payment-icon' />

                                        Google</label>
                                </div>
                                <div>
                                    <input type="radio" className="form-check-input" id='google' value="Google" name="payment" checked={inputField.payment === "Google"} />
                                </div>
                            </div>
                            {inputField.payment === "Google" ?
                                <div className='my-3' >

                                    <div className=' mb-3' >
                                        <TextInput
                                            type="text"
                                            placeholder="Enter Your upi Id"
                                            id="googleupi"
                                            size="small"
                                            varient='filled'
                                        />

                                    </div>
                                </div> : null
                            }
                        </div>

                        <div>
                            <div className='d-flex my-2 flex-row card px-4 py-2 justify-content-between align-items-center' >
                                <div>
                                    <label htmlFor='cash' >
                                        <img src={cod} className='payment-icon' />

                                        Cash
                                    </label>
                                </div>
                                <div>
                                    <input type="radio" className="form-check-input" id='cash' value="Cash" name="payment" checked={inputField.payment === "Cash"} />
                                </div>
                            </div>
                            {inputField.payment === "Cash" ?
                                <div className='my-3' >
                                    <h5 className='mb-3 mt-2' >Cash Payment</h5>
                                    <div className='P-3' >
                                        <p className='text-secondary fs14 mb-3' >Please use this payment menthod only if you are certain that someone will be available to recieve and pay for your order upon delivery. If you intend to leave the address you provided, kindly endorse your payment to another party to ensure your order is deliver successfully. </p>
                                        <p className='text-secondary fs14' >Please prepare the exact amount reflected on your invoice upon delivery.</p>
                                    </div>
                                </div> : null
                            }
                        </div>


                    </div>

                    <div className='mt-2 mb-5' >

                        <Checkbox
                            checked={checked}
                            onChange={handleChange}
                            id='agree-checkbox'
                        />
                        <label htmlFor='agree-checkbox' >I agree with <Link to='/' className='accentColor' >Terms and conditions</Link></label>
                    </div>

                    <Link to="/" ><button type="button" className="btn w-100  img-btn primaryColor">Pay<span className='font ms-1' >K540</span> </button></Link>

                </div>
                {/* <div className='col-md-4 px-4' >
                  
                            <div className='d-flex align-items-center gap-3' >
                                <p className='secondaryColor fs2' >McLaren 750s</p>
                                <p className=' rounded-5 px-2 driver-badge' ><RxDotFilled className=' my-auto' />With Driver</p>

                            </div>
                                <div className='d-flex align-items-center justify-content-between ' >

                                </div>
                                <img src="https://t3.ftcdn.net/jpg/01/23/52/24/240_F_123522493_qV0XZfz5gH3zeWFq1YiNCwpDT8HPfvZL.jpg" className="summary-img mt-3" alt="car-image" />

                            <div className='py-3 py-md-0 col-md-8 my-auto' >
                                <div className='' >



                                    <div>
                                        <div className='d-flex flex-row  my-2 flex-wrap gap-5' >
                                            <div className='d-flex flex-column' >
                                                <p className='fs24'><IoPerson className='feature-icon fs14' />5 Seater</p>
                                                <p className='fs24'><LuAirVent className='feature-icon fs14' />Air Conditioning</p>
                                                <p className='fs24'><FaMusic className='feature-icon fs14' />Music</p>
                                            </div>
                                            <div className='d-flex flex-column' >
                                                <p className='fs24'><HiColorSwatch className="feature-icon fs14" />Color</p>
                                                <p className='fs24'><BsFillFuelPumpFill className='feature-icon fs14' />Full tank</p>
                                                <p className='fs24'><GrManual className='feature-icon fs14' />Manual</p>
                                            </div>
                                        </div>

                                    </div>

                                    <div className='d-flex gap-2 align-items-center mt-2' >
                                        <h5>$200/day</h5>

                                        <div>
                                            <p className='star-rating' ><span>4.9</span><span><GrStar /></span></p>
                                        </div>
                                    </div>

                                </div>


                    </div>

                    <div className='px-1 my-4' >

                        <h4 className='font accentColor mb-3' >Driver Details</h4>
                        <div className='d-flex flex-column flex-md-row justify-content-between' >

                            <div>

                                <div className='d-flex flex-row' >
                                    <div className='w-100px d-flex justify-content-between' >
                                        <h6 className='text-dark' >Full Name</h6>
                                        <h6 className='text-dark' >:</h6>

                                    </div>
                                    <p className='text-secondary fs14 ps-3' >Drivers Name</p>
                                </div>

                                <div className='d-flex flex-row' >
                                    <div className='w-100px d-flex justify-content-between' >
                                        <h6 className='text-dark' >Age</h6>
                                        <h6 className='text-dark' >:</h6>
                                    </div>
                                    <p className='text-secondary fs14 ps-3 ' >44</p>
                                </div>
                            </div>
                            <div >

                                <div className='d-flex flex-row' >
                                    <div className='w-100px d-flex justify-content-between' >
                                        <h6 className='text-dark' >Email</h6>
                                        <h6 className='text-dark' >:</h6>
                                    </div>
                                    <p className='text-secondary fs14 ps-3' >example@gmail.com</p>
                                </div>

                                <div className='d-flex flex-row' >
                                    <div className='w-100px d-flex justify-content-between' >
                                        <h6 className='text-dark' >Phone </h6>
                                        <h6 className='text-dark' >:</h6>
                                    </div>
                                    <p className='text-secondary fs14 ps-3' >+911234567895</p>
                                </div>
                            </div>
                        </div>



                    </div>

                </div>

                <div className='col-md-4 px-4' >



                            <h5 className='text-secondary ms-2 mt-4' >Select a Payment Method</h5>

                        <div onChange={inputsHandler} >
                            <div>
                                <div className='d-flex my-2 flex-row card px-4 py-2 justify-content-between align-items-center' >
                                    <div>
                                        <label htmlFor='card' ><BsCreditCardFill className='credit-icon' />Card</label>
                                    </div>
                                    <div>
                                        <input type="radio" className='form-check-input' id='card' value="Card" name="payment" checked={inputField.payment === "Card"} />
                                    </div>
                                </div>
                                {inputField.payment === "Card" ?

                                    <div className='row my-3 ' >
                                        <div className=' mb-3 col-12' >
                                            <TextInput
                                                type="text"
                                                placeholder="Card Number"
                                                id="cardNumber"
                                                size="small"
                                                varient='filled'
                                            />
                                        </div>
                                        <div className=' mb-3 col-6' >
                                            <TextInput
                                                type="text"
                                                placeholder="MM/YY"
                                                id="month"
                                                size="small"
                                                varient='filled'
                                            />

                                        </div>
                                        <div className=' mb-3 col-6' >
                                            <TextInput
                                                type="text"
                                                placeholder="CVV"
                                                id="cvv"
                                                size="small"
                                                varient='filled'
                                            />

                                        </div>
                                        <div className=' mb-3 col-12' >
                                            <TextInput
                                                type="text"
                                                placeholder="Card Holder Name"
                                                id="cardHolderName"
                                                size="small"
                                                varient='filled'
                                            />

                                        </div>

                                    </div>
                                    : null
                                }
                            </div>

                            <div>
                                <div className='d-flex my-2 flex-row card px-4 py-2 justify-content-between align-items-center' >
                                    <div>
                                        <label htmlFor='paypal' >
                                            <img src={paypal} className='payment-icon' />

                                            Paypal
                                        </label>
                                    </div>
                                    <div>
                                        <input type="radio" className="form-check-input" id='paypal' value="Paypal" name="payment" checked={inputField.payment === "Paypal"} />
                                    </div>
                                </div>
                                {inputField.payment === "Paypal" ?
                                    <div className='my-3' >
                                        <div className=' mb-3' >
                                            <TextInput
                                                type="text"
                                                placeholder="Enter Your Email Id"
                                                id="paypalEmail"
                                                size="small"
                                                varient='filled'
                                            />

                                        </div>
                                    </div> : null
                                }
                            </div>

                            <div>
                                <div className='d-flex my-2 flex-row card px-4 py-2 justify-content-between align-items-center' >
                                    <div>
                                        <label htmlFor='google' >
                                            <img src={googlePay} className='payment-icon' />

                                            Google</label>
                                    </div>
                                    <div>
                                        <input type="radio" className="form-check-input" id='google' value="Google" name="payment" checked={inputField.payment === "Google"} />
                                    </div>
                                </div>
                                {inputField.payment === "Google" ?
                                    <div className='my-3' >

                                        <div className=' mb-3' >
                                            <TextInput
                                                type="text"
                                                placeholder="Enter Your upi Id"
                                                id="googleupi"
                                                size="small"
                                                varient='filled'
                                            />

                                        </div>
                                    </div> : null
                                }
                            </div>

                            <div>
                                <div className='d-flex my-2 flex-row card px-4 py-2 justify-content-between align-items-center' >
                                    <div>
                                        <label htmlFor='cash' >
                                            <img src={cod} className='payment-icon' />

                                            Cash
                                        </label>
                                    </div>
                                    <div>
                                        <input type="radio" className="form-check-input" id='cash' value="Cash" name="payment" checked={inputField.payment === "Cash"} />
                                    </div>
                                </div>
                                {inputField.payment === "Cash" ?
                                    <div className='my-3' >
                                        <h5 className='mb-3 mt-2' >Cash Payment</h5>
                                        <div className='P-3' >
                                            <p className='text-secondary fs14 mb-3' >Please use this payment menthod only if you are certain that someone will be available to recieve and pay for your order upon delivery. If you intend to leave the address you provided, kindly endorse your payment to another party to ensure your order is deliver successfully. The standard, but not guaranteed, timefare for shipping is betweeen 2 and 7 days. </p>
                                            <p className='text-secondary fs14' >Please prepare the exact amount reflected on your invoice upon delivery.</p>
                                        </div>
                                    </div> : null
                                }
                            </div>


                        </div>


                </div>

                <div className='col-md-4 px-4' >

                    <div className="card">
                        <div className="card-header">
                            <h3 className='font' >Payment Detail</h3>
                        </div>
                        <div className="card-body">
                            <dl className="row">
                                <dd className="col-sm-8">Per day car ret</dd>
                                <dd className="col-sm-4 text-end">$220</dd>
                                <dd className="col-sm-8">Total 2 days car rent </dd>
                                <dd className="col-sm-4 text-end">$440</dd>
                            </dl>
                            <hr />
                            <dl className="row">
                                <dt className="col-sm-8">Total payment</dt>
                                <dt className="col-sm-4 text-end">$440</dt>
                            </dl>
                        </div>
                    </div>

                    <div className='mt-2 mb-5' >

                        <Checkbox
                            checked={checked}
                            onChange={handleChange}
                            id='agree-checkbox'
                        />
                        <label htmlFor='agree-checkbox' >I agree with <Link to='/' className='accentColor' >Terms and conditions</Link></label>
                    </div>

                    <Link to="/" ><button type="button" className="btn w-100 img-btn primaryColor">Payment</button></Link>

                </div> */}

            </div>
        </div>
    )
}

export default Index
